import baseEnum from './base-enum'
export let contentTypes = Object.assign(
  {},
  {
    Html: 'html',
    JsonData: 'json-data',
    HtmlData: 'html-data',

    name(val) {
      switch (val) {
        case this.Html:
          return 'Визивиг редактор'
        case this.JsonData:
          return 'Форма по шаблону'
        case this.HtmlData:
          return 'Блочный редактор'
      }
    }
  },
  baseEnum
)
